import Immutable, { Map, Iterable, fromJS } from 'immutable';

export const LOAD_PRODUCTCATEGORIES = 'LOAD_PRODUCTCATEGORIES';
export const UNLOAD_PRODUCTCATEGORIES = 'UNLOAD_PRODUCTCATEGORIES';
export const UPDATE_PRODUCTCATEGORIES = 'UPDATE_PRODUCTCATEGORIES';


export default function ProductCategories(state, action) {

    switch(action.type) {

        case LOAD_PRODUCTCATEGORIES:

            if(action.loading) {
                state = state.setIn(['loading'], true);
            }

            if(action.collection) {
                state = state.setIn(['collection'], Immutable.fromJS(action.collection).groupBy(x => x.get('id')).map(x => x.first()))
            }

            if(action.lastSynced) {
                state = state.setIn(['lastSynced'], action.lastSynced);
            }

            return state;
        case UNLOAD_PRODUCTCATEGORIES:

            return state;
        case UPDATE_PRODUCTCATEGORIES:

            if(action.single) {
                let single = Iterable.isIterable(action.single) ? action.single : fromJS(action.singe); 
                state = state.setIn(['collection', single.get('id')], single);
            }

            return state;

            default:
    }

    return state || Map();

}